import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { trimStart } from 'lodash';

import { FormLabel, InputField, FormErrorText } from 'v-c/Forms';

import styles from './tabs.scss';

const BASE_KEY = 'components.templates.edit_user';

export default class BasicInfoTab extends Component {
    static propTypes = {
        validators: PropTypes.object.isRequired,
        reactForm: PropTypes.shape({
            fields: PropTypes.object.isRequired,
        }).isRequired,
        getMessage: PropTypes.func.isRequired,
        status: PropTypes.string.isRequired,
    };

    onUsernameChange = ({ target }) => {
        this.props.reactForm.fields.username.change(target.value.replace(' ', ''));
    };

    onNameChange = field => ({ target }) => {
        field.change(trimStart(target.value));
    };

    render() {
        const {
            getMessage,
            reactForm: { fields },
            validators,
            status,
        } = this.props;

        return (
            <div className={`basic-info-section ${styles['accordion-content']}`}>
                <div className={styles['tab-content-column']}>
                    <div className={styles['form-row']}>
                        <FormLabel required hint={getMessage(`${BASE_KEY}.username_hint`)}>
                            {getMessage(`${BASE_KEY}.username`)}
                        </FormLabel>
                        <div className={styles['medium-input']}>
                            <InputField
                                type="text"
                                focused
                                data-field="username"
                                value={fields.username.value}
                                onChange={this.onUsernameChange}
                                status={status}
                            />
                        </div>
                        <FormErrorText
                            field="username-form-error"
                            error={validators.username}
                            values={{ field: 'USERNAME' }}
                        />
                    </div>
                    <div className={styles['form-row']}>
                        <FormLabel required>
                            {getMessage(`${BASE_KEY}.first_name`)}
                        </FormLabel>
                        <div className={styles['medium-input']}>
                            <InputField
                                type="text"
                                data-field="first-name"
                                value={fields.firstName.value}
                                onChange={this.onNameChange(fields.firstName)}
                                status={status}
                            />
                        </div>
                    </div>
                    <div className={styles['form-row']}>
                        <FormLabel required>
                            {getMessage(`${BASE_KEY}.last_name`)}
                        </FormLabel>
                        <div className={styles['medium-input']}>
                            <InputField
                                type="text"
                                data-field="last-name"
                                value={fields.lastName.value}
                                onChange={this.onNameChange(fields.lastName)}
                                status={status}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ clear: 'left' }} />
            </div>
        );
    }
}
